import { render, staticRenderFns } from "./ReportCardDateAndTime.vue?vue&type=template&id=2b4ee778&scoped=true&"
import script from "./ReportCardDateAndTime.vue?vue&type=script&lang=ts&"
export * from "./ReportCardDateAndTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ee778",
  null
  
)

export default component.exports